import { useEffect, useState, useCallback, useRef } from "react";
import icon from "../../../assets/icons/icon_for_web_push_notification.png"; 

const NotificationHandler = ({ newTitle, message, count }) => {
  const [originalTitle, setOriginalTitle] = useState(document.title);
  const [isBlinking, setIsBlinking] = useState(false); 
  const [intervalId, setIntervalId] = useState(null);
  const lastNotification = useRef({ title: "", message: "", count: 0 }); 

  useEffect(() => {

    setOriginalTitle(document.title);

    const handleFocus = () => {
      clearInterval(intervalId); 
      document.title = originalTitle;
      setIsBlinking(false);
    };

    window.addEventListener("focus", handleFocus);

    return () => {
      window.removeEventListener("focus", handleFocus);
      clearInterval(intervalId);
    };
  }, [originalTitle, intervalId]);

  const startTitleBlinking = useCallback(() => {
    if (!isBlinking && newTitle) {
      const blinkId = setInterval(() => {
        document.title = document.title === newTitle ? originalTitle : newTitle;
      }, 1000); 
      setIntervalId(blinkId);
      setIsBlinking(true);
    }
  }, [isBlinking, newTitle, originalTitle]);

  const showNotification = useCallback(() => {
    if ("Notification" in window && Notification.permission === "granted") {
      new Notification("New signal", {
        body: message,
        icon: icon, 
        requireInteraction: true,
      });
    }
  }, [message]);

  useEffect(() => {
    if (lastNotification.current.count !== count && count > 0) {
  
      lastNotification.current = { title: newTitle, message, count };
  
      if (Notification.permission === "default") {
        Notification.requestPermission();
      }
      if (!document.hasFocus()) {
        startTitleBlinking();
      }
      showNotification();
    }
  }, [newTitle, message, count, showNotification, startTitleBlinking]);

  return null; 
};

export default NotificationHandler;
